import React from 'react'
import List from './List'
import { useCandidateExhibitById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateExhibitById(id)
  return (
    <List candidate={candidate} />
  )
}

export default Body
